export const fieldWidth = 649; // Field width in pixels
export const fieldHeight = 492; // Field height in pixels
export const fieldPadding = 5;